export function remoteControlSetpointOf(value: string | null): number | null {
  const informed = value?.trim();

  return informed ? Number(informed) : null;
}

export function areRemoteControlSetpointsNumeric(minimum: string | null, maximum: string | null): boolean {
  return [remoteControlSetpointOf(minimum), remoteControlSetpointOf(maximum)]
    .every((value) => value === null || Number.isFinite(value));
}

export const ALLOWED_SETPOINT_RANGE = { minimum: 10, maximum: 40 };

export function areRemoteControlSetpointsInRange(minimum: string | null, maximum: string | null): boolean {
  return [remoteControlSetpointOf(minimum), remoteControlSetpointOf(maximum)]
    .every((value) => value === null
      || (value >= ALLOWED_SETPOINT_RANGE.minimum && value <= ALLOWED_SETPOINT_RANGE.maximum));
}

export function isRemoteControlSetpointRangeValid(minimum: string | null, maximum: string | null): boolean {
  const minimumSetpoint = remoteControlSetpointOf(minimum);
  const maximumSetpoint = remoteControlSetpointOf(maximum);
  if (minimumSetpoint === null || maximumSetpoint === null) return true;

  return minimumSetpoint < maximumSetpoint;
}
